import React from "react";
import "./css/policy.css";

const Policy = () => {
    const name = process.env.REACT_APP_APP_NAME || "ExamWorld";

    return (
        <div className="policyMainContainer">
            {/* Header */}
            <header className="policyHeaderContainer">
                <h2 className="policyTitle">Privacy Policy & DPDP Compliance</h2>
                <p className="policyDate">
                    Effective Date: <strong>01 January 2026</strong>
                </p>
            </header>

            {/* Introduction */}
            <section className="policySection">
                <p>
                    Welcome to <strong>{name}</strong>. We are committed to protecting the integrity and privacy of your personal data.
                    This document serves as a digital contract between you (the "User") and <strong>{name}</strong>.
                </p>
                <p>
                    This policy is drafted in accordance with the <strong>Digital Personal Data Protection Act, 2023 (DPDP Act)</strong>,
                    the <strong>Information Technology Act, 2000</strong>, and <strong>CERT-In Guidelines</strong>.
                </p>
            </section>

            {/* Detailed Data Collection */}
            <section className="policySection">
                <h2>1. Information We Collect</h2>
                <p>We process your data strictly under the principle of Data Minimization.</p>
                <ul className="policyList">
                    <li><strong>Identity & Contact:</strong> Full name, mobile number, and email address for account verification.</li>
                    <li><strong>Academic Records:</strong> Test scores, accuracy rates, and progress reports for Performance Analytics.</li>
                    <li><strong>Technical Data:</strong> IP addresses and device identifiers for security auditing and fraud prevention.</li>
                </ul>
            </section>

            {/* Minors Data Clause (New Addition) */}
            <section className="policySection">
                <h2>2. Protection of Minors' Data</h2>
                <p>
                    In strict compliance with the DPDP Act, 2023, {name} implements special protections for users under the age of 18:
                </p>
                <ul className="policyList">
                    <li><strong>Verifiable Parental Consent:</strong> We require the consent of a lawful guardian before processing the data of a minor.</li>
                    <li><strong>No Targeted Ads:</strong> We strictly prohibit behavioral tracking or targeted advertising directed at children.</li>
                    <li><strong>No Harmful Processing:</strong> We do not process data in any manner that could cause harm to the well-being of a minor.</li>
                </ul>
            </section>

            {/* Data Sharing */}
            <section className="policySection">
                <h2>3. Data Disclosure & Sharing</h2>
                <p>
                    At {name}, we adhere to a strict "No-Sale" policy. We do not trade, rent, or sell your personal data.
                </p>
                <ul className="policyList">
                    <li><strong>Data Processors:</strong> We share data only with authorized infrastructure partners (Cloud hosting, Payment Gateways) under strict Data Processing Agreements.</li>
                    <li><strong>Identity Masking:</strong> For technical maintenance, we use Pseudonymization. We only share a Platform-Specific Account ID with external systems, ensuring your real-world identity remains hidden.</li>
                </ul>
            </section>

            {/* Security & CERT-In Compliance */}
            <section className="policySection">
                <h2>4. Data Security & Incident Reporting (CERT-In)</h2>
                <p>
                    We utilize industry-leading protocols (SSL/TLS Encryption, JWT, Salted Hashing) to protect your information.
                </p>
                <h3>4.1 Mandatory Breach Notification</h3>
                <p>
                    In the highly unlikely event of a cyber security incident or data breach, {name} is legally bound by the Indian Computer Emergency Response Team (CERT-In) guidelines:
                </p>
                <ul className="policyList">
                    <li><strong>6-Hour Reporting:</strong> We will report severe security incidents to CERT-In within 6 hours of noticing the breach.</li>
                    <li><strong>User Notification:</strong> We will inform the affected Data Principals (Users) without undue delay alongside the Data Protection Board.</li>
                </ul>
            </section>

            {/* Rights of the Data Principal */}
            <section className="policySection">
                <h2>5. Rights of the Data Principal (Your Rights)</h2>
                <p>Under Chapter III of the DPDP Act 2023, you have the right to:</p>
                <ul className="policyList">
                    <li><strong>Access:</strong> View a summary of your personal data processed by us.</li>
                    <li><strong>Correction:</strong> Update inaccurate information in your profile settings.</li>
                    <li><strong>Erasure:</strong> Request the deletion of your account and personal data (subject to legal retention periods for financial audits).</li>
                    <li><strong>Withdraw Consent:</strong> Withdraw your consent for non-essential data processing (like promotional alerts).</li>
                </ul>
            </section>

            {/* Grievance Officer (Updated Details) */}
            <section className="policySection">
                <h2>6. Grievance Redressal Mechanism</h2>
                <p>
                    If you believe your data rights have been violated, or if you have concerns regarding our policies, you have the right to file a complaint. Under the Information Technology Act and DPDP Act, we have appointed a dedicated Grievance Officer.
                </p>
                <div style={{ backgroundColor: '#eff6ff', padding: '15px', borderRadius: '8px', borderLeft: '4px solid #2563eb', marginTop: '10px' }}>
                    <h3 style={{ marginTop: '0', color: '#1f2937' }}>Grievance Officer Details:</h3>
                    <ul className="policyList" style={{ marginBottom: '0' }}>
                        <li><strong>Name:</strong> Ashutosh Kumar</li>
                        <li><strong>Designation:</strong> Data Protection & Grievance Officer</li>
                        <li><strong>Email:</strong> grievance@examworld.in</li>
                        <li><strong>Resolution Time:</strong> We aim to acknowledge complaints within 24 hours and resolve them within 15 days of receipt.</li>
                    </ul>
                </div>
            </section>

            {/* Footer */}
            <footer className="policyFooter">
                <h3>Declaration of Consent</h3>
                <p>
                    By using <strong>{name}</strong>, you acknowledge that you have read, understood, and accept our Privacy practices. You provide your express, informed, and unconditional consent for us (the Data Fiduciary) to process your personal data for educational and security purposes as described in this Policy.
                </p>
            </footer>
        </div>
    );
};

export default Policy;